module.exports = __webpack_public_path__ + "img/文件.200ba296.png";